import { render, staticRenderFns } from "./SettingsComponent.vue?vue&type=template&id=17d85f1a"
import script from "./SettingsComponent.vue?vue&type=script&lang=js"
export * from "./SettingsComponent.vue?vue&type=script&lang=js"
import style0 from "./SettingsComponent.vue?vue&type=style&index=0&id=17d85f1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports